import React from 'react'
import Product1 from '../components/Product1/Product1'
import Product from '../components/Product/Product'

const Products = () => {
  return (
    <div className='products'>
        <Product/>
        <Product1/>
    </div>
  )
}

export default Products